const Format = require('google-libphonenumber').PhoneNumberFormat
const Util   = require('google-libphonenumber').PhoneNumberUtil.getInstance()

const phoneNumberFormat = (value, countryCode, format) =>
{
	try
	{
		countryCode = countryCode || 'US'
		format      = format || Format.INTERNATIONAL

		let result = Util.parse(value, countryCode)

		return ( Util.isValidNumber(result) ) ? Util.format(result, format) : value
	}
	catch (e)
	{
		console.error && console.error(e)

		return value
	}
}

export default phoneNumberFormat